import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '../reducers';

export const getInsuranceList = (state: RootState) => state.insurances.list;

export const getRetailerDocument = createSelector(
  (state: RootState) => state.retailers.single,
  (documentList) =>
    documentList && documentList.documents.length === 1 ? documentList.documents[0] : null,
);

export const getRetailerId = createSelector(
  getRetailerDocument,
  (retailer) => retailer?.id || null,
);
